export const computeExtractionArea = (
  originalWidth: number,
  originalHeight: number,
  aspectRatio: number,
  focalPoint: {
    left: number,
    top: number
  } | undefined
) => {

  // Calculate the target section dimensions while maintaining aspect ratio
  let targetWidth = originalWidth;
  let targetHeight = (1 / aspectRatio) * targetWidth;

  if (targetHeight > originalHeight) {
    targetHeight = originalHeight;
    targetWidth = (aspectRatio) * targetHeight;
  }

  focalPoint = focalPoint ?? {left: 50, top: 50};
  // Calculate the focal point coordinates in pixels
  const focalX = (focalPoint.left / 100) * originalWidth;
  const focalY = (focalPoint.top / 100) * originalHeight;

  // Calculate the top-left corner of the target section
  let left = focalX - targetWidth / 2;
  let top = focalY - targetHeight / 2;

  // Adjust if the target section extends beyond the original image boundaries
  if (left < 0) left = 0;
  if (top < 0) top = 0;
  if (left + targetWidth > originalWidth) left = originalWidth - targetWidth;
  if (top + targetHeight > originalHeight) top = originalHeight - targetHeight;

  const extract = {
    left: Math.floor(left),
    top: Math.floor(top),
    width: Math.floor(targetWidth),
    height: Math.floor(targetHeight),
  };


  return `${extract.left}_${extract.top}_${extract.width}_${extract.height}`;
}
